import moment from "moment";
import numeral from "numeral";

import { Component, Vue} from "vue-property-decorator";

numeral.localeData().delimiters.thousands = " ";

/**
 * Contains global functions. Inherited from Vue base class
 * @extends Vue
 */
@Component
export default class GlobalMixins extends Vue {
  formatDateTime(d) {
    if (d != null) {
      return moment(d).format("YYYY-MM-DD HH:mm:ss");
    } else {
      return "";
    }
  }

  formatDate(d) {
    if (d != null) {
      return moment(d).format("YYYY-MM-DD");
    } else {
      return "";
    }
  }

  formatTime(d) {
    if (d != null) {
      return moment(d).format("HH:mm:ss");
    } else {
      return "";
    }
  }

  todaysDate() {
    const d = new Date();
    return this.formatDate(d);
  }

  firstDayInPrevMonth() {
    const d = new Date();
    d.setMonth(d.getMonth() - 1);
    d.setDate(1);
    return this.formatDate(d);
  }

  lastDayInPrevMonth() {
    const d = new Date();
    d.setDate(1);
    d.setHours(-1);
    return this.formatDate(d);
  }

  formatNumber(value) {
    return numeral(value).format("0,0");
  }

  openOrderOnMap(order) {
    const address = order.realEstateCity.name + ", " + order.realEstateAddress;
    const url = "https://www.google.com/maps/search/?api=1&query=" + address;
    window.open(url, "_blank");
  }

}
